export type RecorderPermission = "granted" | "denied" | "prompt"

type RecorderErrorKind =
	| "permission"
	| "unavailable"
	| "empty"
	| "noData"
	| "noTrack"
	| "timeout"

export class RecorderError extends Error {
	readonly kind: RecorderErrorKind

	constructor(kind: RecorderErrorKind, options?: { cause?: unknown }) {
		super(kind, options)
		this.name = "RecorderError"
		this.kind = kind
	}
}

export interface RecorderResult {
	blob: Blob
	durationMs: number
	fileName: string
}

export interface VoiceRecorder {
	checkPermission(): Promise<RecorderPermission>
	requestPermission(): Promise<RecorderPermission>
	start(): Promise<void>
	stop(): Promise<RecorderResult>
	cancel(): Promise<void>
	onInterruption(listener: () => void): () => void
}

export function toPermission(state: string): RecorderPermission {
	if (state === "granted") return "granted"
	if (state === "denied") return "denied"
	return "prompt"
}
